import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles.css";
import { UiLanguageProvider } from "./UiLanguageProvider";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <UiLanguageProvider>
      <App />
    </UiLanguageProvider>
  </StrictMode>,
);
